import { TaskTeam } from '../types';

const TEAM_KEYWORDS: Record<TaskTeam, string[]> = {
  HR: [
    'hr', 'human resource', 'payroll', 'salary', 'attendance', 'leave',
    'employee', 'recruit', 'recruiting', 'hiring', 'hire', 'interview',
    'interviews', 'candidate', 'onboarding', 'offboarding', 'appraisal',
    'performance review', 'job', 'offer letter', 'resignation',
  ],
  Engineering: [
    'engineer', 'engineering', 'frontend', 'backend', 'bug', 'build',
    'develop', 'development', 'code', 'coding', 'interface', 'ux', 'software',
    'feature', 'task board', 'dashboard', 'design', 'component', 'api',
    'database', 'deploy', 'server', 'integration', 'testing', 'qa',
  ],
  Finance: [
    'finance', 'financial', 'p&l', 'invoice', 'payment', 'revenue', 'billing',
    'budget', 'cost', 'expense', 'accounts', 'gst', 'tax', 'audit', 'ledger',
    'cash flow', 'profit', 'loss', 'reconcil',
  ],
  Sales: [
    'sales', 'lead', 'leads', 'prospect', 'deal', 'pitch', 'conversion',
    'target', 'quota', 'demo', 'follow up', 'pipeline',
  ],
  KAM: [
    'kam', 'key account', 'client', 'account', 'onboard', 'customer',
    'relationship', 'retention', 'renewal', 'contract', 'sla',
  ],
  Management: [
    'ceo', 'board meeting', 'strategic', 'strategy', 'executive', 'stakeholder',
    'roadmap', 'vision', 'policy', 'governance', 'leadership',
  ],
  Operations: [
    'ops', 'operations', 'dispatch', 'transit', 'inventory', 'shift',
    'logistics', 'warehouse', 'fulfillment', 'delivery', 'vehicle',
    'facility', 'city', 'route',
  ],
};

export function detectTeam(text: string): TaskTeam {
  const lower = text.toLowerCase();
  const scores: Record<TaskTeam, number> = {
    HR: 0, Engineering: 0, Finance: 0, Sales: 0,
    KAM: 0, Management: 0, Operations: 0,
  };

  for (const [team, keywords] of Object.entries(TEAM_KEYWORDS) as [TaskTeam, string[]][]) {
    for (const kw of keywords) {
      if (lower.includes(kw)) scores[team]++;
    }
  }
  // word-boundary check for "ui" (otherwise "build" etc. could false-match)
  if (/\bui\b/.test(lower)) scores.Engineering++;

  // management gets a point if "management" appears but NOT in "project/task management"
  if (lower.includes('management') && !lower.includes('project management') && !lower.includes('task management')) {
    scores.Management++;
  }

  const [bestTeam, bestScore] = (Object.entries(scores) as [TaskTeam, number][])
    .reduce<[TaskTeam, number]>(
      ([bt, bs], [team, score]) => score > bs ? [team, score] : [bt, bs],
      ['Operations', 0]
    );

  return bestScore > 0 ? bestTeam : 'Operations';
}
